import React from 'react';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import PersonalInformation from './PersonalInformationComponent';

import { userRoles } from '../../constants/constants';

let PersonalInformationForm = ({ user, hasWritePermission }) => (
  <fieldset disabled={!hasWritePermission} className="form personal-information-form">
    <PersonalInformation user={user} hasWritePermission={hasWritePermission} />
  </fieldset>
);



PersonalInformationForm = reduxForm({
  form: 'caseGeneralInformation',
  enableReinitialize: true,
})(PersonalInformationForm);
const mapStateToProps = state => {
  const {
    auth: { user },
  } = state;

  const hasWritePermission = user.role === userRoles.admin || user.role === userRoles.surgeon;
  return {
    user,
    initialValues: state._case.selectedCase.partOneGeneralInformation,
    hasWritePermission,
  };
};

PersonalInformationForm = connect(mapStateToProps)(PersonalInformationForm);

export default PersonalInformationForm;
